import api from '../../utils/api';

// TODO generate query by passed in parameters
export default {
  post: (data) => api.makeEndpoint('post', 'contact/')({ data }),
};
